var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #80d4d4;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke: #00a9a9;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 30px;\n      }\n\n      .cls-4 {\n        fill: #bfeaea;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 600,
    cy: 600.18,
    r: 557.49
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M913.47,288.5l107.66,14.36c-.77,1.54-1.92,2.95-3.21,4.23l-79.98,79.98-108.43-14.61-16.28-110.1,56.91-56.91.13.13,26.66-26.66c.13-.13.38-.13.51-.26l16.02,109.84Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 591.96,
    cy: 611.74,
    r: 337.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 593.54,
    cy: 611.74,
    r: 216.51
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 591.96,
    cy: 611.74,
    r: 85.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 590.12,
    y1: 611.74,
    x2: 829.47,
    y2: 372.39
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.285c4db0cc07da9849e29a6a10b27c29.svg";
export { ForwardRef as ReactComponent };